import {
    NotFoundErrorResponse,
    ErrorResponse,
    UnprocessableErrorResponse,
} from ".";
// import { AppApiRequestActionEnum } from "../../enum/AppApiRequestAction.enum";

// type ErrorType = null | string | ErrorResponse | AppApiRequestActionEnum;
type ErrorType = null | string | ErrorResponse;

export class FinalResponse<R> {
    response: null | R;

    error: ErrorType;

    // to handle 404,
    // if the entity doesn't exist, while fetching or deleting an entity,
    isNotFound = false;

    // to handle 422,
    // if the entity is not valid or violation occurred, while creating or updating an entity,
    isInvalid = false;

    // to handle cancel request
    // if made request is being cancelled
    isCancel = false;

    errorMessage = "";

    constructor(response: R | null = null, error: ErrorType = null) {
        this.error = error;
        this.response = response;

        if (error instanceof NotFoundErrorResponse) {
            this.isNotFound = true;
        }

        if (error instanceof UnprocessableErrorResponse) {
            this.isInvalid = true;
        }

        /*
        if (error === AppApiRequestActionEnum.CANCELLED) {
            this.isCancel = true;
        }
        */

        if (error !== null) {
            if (typeof error === "string") {
                this.errorMessage = error;
            }

            if (error instanceof ErrorResponse) {
                this.errorMessage = error.description;
            }
        }
    }
}
